






















import { Component, Prop, Vue } from 'vue-property-decorator';
import { HOST } from '@/global';

@Component({
  name: 'DownloadableForms',
  components: {}
})
export default class DownloadableForms extends Vue {
  @Prop() compData: any;
  HOST: string = HOST;

  get forms(): Array<any> | null {
    if (this.compData != null) {
      return this.compData.map((item: any, idx: any) => {
        const fileparts = item.view.split('.');
        item.extension = fileparts[fileparts.length - 1].toLowerCase();
        return item;
      });
    } else {
      return null;
    }
  }
}
